import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ICreateDirectMessagePayload {
    data: {
        username?: string
        usernames?: string[]
        excludeSelf?: boolean
    }
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: [],
    errors: null
}

const createDirectMessageSlice = createSlice({
    name: 'chat/create-direct-message',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateDirectMessagePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.messages
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createDirectMessageActions = createDirectMessageSlice.actions
export default createDirectMessageSlice.reducer
